import { isOpenableUrl } from '../../context/platform/isOpenableUrl'

export class BrowserPlatform {
    get name() {
        return 'browser'
    }

    get router() {
        return 'browser'
    }

    get env() {
        return {}
    }

    get isDesktopApp() {
        return false
    }

    get scannedImagesLocation() {
        return ''
    }

    async getAppVersion() {
        const { version } = await import('../../../package.json')
        return version
    }

    async checkForUpdates() {
        console.log('checkForUpdates is not supported on this platform')
    }

    readFileSync(path) {
        console.log('readFileSync is not supported on this platform')
    }

    existsSync(path) {
        console.log('existsSync is not supported on this platform')
        return false
    }

    showMessageBoxSync({ title, message }) {
        alert(`${title}: ${message}`)
    }

    onMessage(callback) {
        console.log('onMessage is not supported on this platform')
    }

    // No Electron shell to bridge to, so a new tab stands in; either way the current
    // page never navigates.
    openExternalUrl(url) {
        if (!isOpenableUrl(url)) {
            return false
        }
        window.open(url, '_blank', 'noopener,noreferrer')
        return true
    }

    // A refresh continues the session the user is already in; a fresh load or a new
    // tab starts one. Read from the navigation entry rather than remembered, so
    // nothing has to be stored or cleared.
    isSessionStart() {
        const [navigation] = window.performance?.getEntriesByType?.('navigation') ?? []

        return navigation?.type !== 'reload' && navigation?.type !== 'back_forward'
    }
}
